module.exports = {
	'detailBandwidthPackages': '/api/cps/bandwidthPackages', //查询共享带宽详情
	'listElasticIps': '/api/cps/listElasticIps', //查询eip列表
};



// WEBPACK FOOTER //
// ./src/api/sbw/detail/config.js